import { useState, useEffect } from 'react';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

// Reusable single-select for picking an existing managed Brand, used by
// the Add Product and Edit Product forms (including per-variation brand
// pickers). `value` is the brand name string; `onChange` receives the
// newly selected brand name (or "" if cleared).
const BrandSelect = ({ value, onChange, label = "Brand (optional)" }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                const { data } = await axios.get('/api/v1/admin/brands');
                setOptions(data.brands.map((b) => b.name));
            } catch (error) {
                console.error('Failed to load brands', error);
            }
        };
        fetchBrands();
    }, []);

    return (
        <Autocomplete
            size="small"
            options={options}
            value={value || null}
            onChange={(e, newValue) => onChange(newValue || "")}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder="Search brands..."
                    helperText="Don't see it? Add it first under Admin > Brands"
                />
            )}
        />
    );
};

export default BrandSelect;
